import * as yup from 'yup';

import actionProfiles from '+/models/actionProfiles';
import TextReader from '+/utils/TextReader';

const ACTION_TYPES = Object.keys(actionProfiles);
const { t } = new TextReader('errorMessages');

export default yup.object().shape({
  customActionTypesEnabled: yup.array().of(yup.number()),
  emailEnabled: yup.boolean(),
  facebookEnabled: yup.boolean(),
  phoneEnabled: yup.boolean(),
  petitionEnabled: yup.boolean(),
  linkedinEnabled: yup.boolean(),
  otherEnabled: yup.boolean(),
  twitterEnabled: yup.boolean(),
  somethingEnabled: yup
    .boolean()
    .nullable()
    .when(ACTION_TYPES.map(a => `${a}Enabled`).concat(['customActionTypesEnabled']), {
      is: (...args) => {
        const actions = args.slice(0, args.length - 1);
        const customActionTypesEnabled = args[args.length - 1];
        return actions.every(a => a === false) && !customActionTypesEnabled[0];
      },
      then: yup.boolean().test({
        name: 'actionsEnabled',
        message: t('atLeastOneActionTypeEnabled'),
        test: val => val,
      }),
    }),
  emailClient: yup.string().nullable(),
  newActionEmailNotificationsEnabled: yup.boolean(),
  newActionBrowserNotificationsEnabled: yup.boolean(),
});
